// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.listings.accountview.zrm.enums.AccountViewListingGroupType

export enum AccountViewListingGroupType {
  LISTING = 'LISTING',
  MULTIPLEX = 'MULTIPLEX',
}

export const AccountViewListingGroupType_values = [
  AccountViewListingGroupType.LISTING,
  AccountViewListingGroupType.MULTIPLEX,
] as const;
